import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CommonServices } from '../services/commonServices';
const commonServices = new CommonServices();

import { Loadingfuction } from '../store/reducers/loading.reducer';

// widgets
import TextInput from '../widget/w-textInput';
import ButtonComp from '../widget/w-button';
import TextMsg from '../widget/common/textMessage';
import REGEX_VALID from '../widget/common/regexValidation';
import { toast } from 'react-toastify';
import Toaster from '../widget/w-toaster';
import DropDown from '../widget/w-dropDownSearch';
import countryCodes from '../widget/common/CountryCodes';
import Image from '../widget/w-image';

interface ModalProps {}
const Login: React.FC<ModalProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [screenNumber, setscreenNumber] = useState(1);
  const [errorText, setErrorText] = useState('');
  const [firstName, setfirstName] = useState('');
  const [firstNameError, setfirstNameError] = useState('');
  const inputFirstNameRef = useRef(null);
  const [lastName, setlastName] = useState('');
  const [lastNameError, setlastNameError] = useState('');
  const inputlastNameRef = useRef(null);
  const [emailId, setemailId] = useState('');
  const [emailIdError, setemailIdError] = useState('');
  const inputemailIdRef = useRef(null);
  const [phoneNumber, setphoneNumber] = useState('');
  const [phoneNumberError, setphoneNumberError] = useState('');
  const inputphoneNumberRef = useRef(null);
  const [Subscription, setSubscription] = useState('');
  const [subscriptionError, setsubscriptionError] = useState('');
  const inputsubscriptionRef = useRef(null);

  const [cityName, setcityName] = useState('');
  const [cityNameError, setcityNameError] = useState('');
  const inputcityNameRef = useRef(null);
  const [countryName, setcountryName] = useState('');
  const [countryNameError, setcountryNameError] = useState('');
  const inputcountryNameRef = useRef(null);
  const [companyName, setcompanyName] = useState('');
  const [companyNameError, setcompanyNameError] = useState('');
  const inputcompanyNameRef = useRef(null);
  const [registerErrorText, setregisterErrorText] = useState('');
  const [registerSuccessText, setregisterSuccessText] = useState('');

  const [license_key, setlicense_key] = useState('');
  const [license_keyError, setlicenseKeyError] = useState('');
  const inputlicenseKeyRef = useRef(null);

  const [countryCode, setCountryCode] = useState({
    name: 'United States',
    label: '+1 (US)',
    value: '+1',
  });
  const handleCountryCodeChange = (selected) => {
    setCountryCode(selected);
  };

  useEffect(() => {
    handleLoading(true);
    getRegionList();
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      const SubscriptionIdFromURL = searchParams.get('sub');
      const subscriptionTypeFromURL = searchParams.get('type');
      sessionStorage.setItem(
        'subscription',
        JSON.stringify({
          subscription_id: SubscriptionIdFromURL,
          subscription_type: subscriptionTypeFromURL,
        }),
      );
      navigate('/signup');
      setregisterErrorText('');
      setregisterSuccessText('');
    }
    getSubscriptionDetails();
    setTimeout(() => {
      handleLoading(false);
    }, 1000);
  }, []);

  const handleLoading = (event: boolean) => {
    dispatch(Loadingfuction({ loading: event }));
  };


  const [selectedCloud, setselectedCloud] = useState(null);
  const [cloudList, setCloudList] = useState([]);
  const [cloudError, setcloudError] = useState('');

  const [selectedRegion, setselectedRegion] = useState(null);
  const [regionList, setRegionList] = useState([]);
  const [regionError, setregionError] = useState('');

  const [showRegisterSuccessScreen, setshowRegisterSuccessScreen] =
    useState(false);

  useEffect(() => {
    if (selectedCloud) {
      const tempRegion = [];
      selectedCloud.value.forEach((element, id) => {
        tempRegion.push({
          label: element.region_name,
          value: element.region_name,
          id: id,
        });
      });
      setRegionList(tempRegion);
    }
  }, [selectedCloud]);

  const getRegionList = () => {
    commonServices
      .regionsApi()
      .then((res: any) => {
        const tempArry = [];
        res.data.forEach((e, ind) => {
          tempArry.push({
            value: e.regions,
            label: e.cloud,
            id: ind,
          });
        });
        setCloudList(tempArry);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  const handlefirstNameValue = (event) => {
    setfirstNameError('');
    setErrorText('');
    event = event.replace(/[^a-zA-Z ]+/g, '');
    setfirstName(event);
    if (event.length > 50) {
      setTimeout(() => {
        setfirstNameError('.');
        inputFirstNameRef.current.focus();
      }, 50);
    }
  };
  const handlelastNameValue = (event) => {
    setlastNameError('');
    setErrorText('');
    event = event.replace(/[^a-zA-Z ]+/g, ' ');
    setlastName(event);
    if (event.length > 50) {
      setTimeout(() => {
        setlastNameError('.');
        inputlastNameRef.current.focus();
      }, 50);
    }
  };
  const handleemailIdValue = (event) => {
    setemailIdError('');
    setErrorText('');
    event = event.replace(/\s+/g, '');
    setemailId(event.toLowerCase());
    if (event.length > 256) {
      setTimeout(() => {
        setemailIdError('.');
        inputemailIdRef.current.focus();
      }, 50);
    }
  };
  const handlephoneNumberValue = (event) => {
    setphoneNumberError('');
    setErrorText('');
    event = event.replace(/[^0-9]+/g, '');
    setphoneNumber(event);
  };
  const handlecityNameValue = (event) => {
    setcityNameError('');
    setErrorText('');
    event = event.replace(/[^a-zA-Z ]+/g, '');
    setcityName(event);
    if (event.length > 100) {
      setTimeout(() => {
        setcityNameError('.');
        inputcityNameRef.current.focus();
      }, 50);
    }
  };
  const handlecountryNameValue = (event) => {
    setcountryNameError('');
    setErrorText('');
    // event = event.replace(/[^a-zA-Z0-9/,.]+/g, ' ');
    event = event.replace(/[^a-zA-Z ]+/g, '');
    setcountryName(event);
    if (event.length > 100) {
      setTimeout(() => {
        setcountryNameError('.');
        inputcountryNameRef.current.focus();
      }, 50);
    }
  };
  const handlecompanyNameValue = (event) => {
    setcompanyNameError('');
    setErrorText('');
    event = event.replace(/[^a-zA-Z0-9 ]+/g, ' ');
    setcompanyName(event);
    if (event.length > 100) {
      setTimeout(() => {
        setcompanyNameError('.');
        inputcompanyNameRef.current.focus();
      }, 50);
    }
  };
  const handlenextButton = () => {
    setfirstNameError('');
    setlastNameError('');
    setemailIdError('');
    if (
      firstName.length < 1 ||
      lastName.length < 1 ||
      firstName.length > 50 ||
      lastName.length > 50
    ) {
      if (firstName.length < 1) {
        setfirstNameError(TextMsg.registerFirstNameError);
        inputFirstNameRef.current.focus();
      } else if (lastName.length < 1) {
        setlastNameError(TextMsg.registerLastNameError);
        inputlastNameRef.current.focus();
      } else if (firstName.length > 50) {
        setTimeout(() => {
          setfirstNameError('.');
          inputFirstNameRef.current.focus();
        }, 50);
      } else if (lastName.length > 50) {
        setTimeout(() => {
          setlastNameError('.');
          inputlastNameRef.current.focus();
        }, 50);
      }
    } else if (
      !new RegExp(REGEX_VALID.email_regex).test(emailId) ||
      phoneNumber.length < 1 ||
      emailId.length > 256 ||
      phoneNumber.length > 16
    ) {
      if (emailId.length == 0) {
        setemailIdError(TextMsg.email_error);
        inputemailIdRef.current.focus();
      } else if (emailId.length > 256) {
        setTimeout(() => {
          setemailIdError('.');
          inputemailIdRef.current.focus();
        }, 50);
      } else if (new RegExp(REGEX_VALID.email_regex).test(emailId) !== true) {
        setemailIdError(TextMsg.email_valid_error);
        inputemailIdRef.current.focus();
      } else if (phoneNumber.length == 0) {
        setphoneNumberError(TextMsg.registerphoneNumberError);
        inputphoneNumberRef.current.focus();
      } else if (phoneNumber.length > 16) {
        setphoneNumberError(TextMsg.registerphoneNumberValidError);
        inputphoneNumberRef.current.focus();
      }
    } else if (
      cityName.length < 1 ||
      countryName.length < 1 ||
      cityName.length > 100 ||
      countryName.length > 100
    ) {
      if (cityName.length == 0) {
        setcityNameError(TextMsg.registercityNameError);
        inputcityNameRef.current.focus();
      } else if (cityName.length > 100) {
        setTimeout(() => {
          setcityNameError('.');
          inputcityNameRef.current.focus();
        }, 50);
      } else if (countryName.length == 0) {
        setcountryNameError(TextMsg.registercountryNameError);
        inputcountryNameRef.current.focus();
      } else if (countryName.length > 100) {
        setTimeout(() => {
          setcountryNameError('.');
          inputcountryNameRef.current.focus();
        }, 50);
      }
    } else if (companyName.length < 1 || companyName.length > 100) {
      if (companyName.length == 0) {
        setcompanyNameError(TextMsg.registercompanyNameError);
        inputcompanyNameRef.current.focus();
      } else if (companyName.length > 100) {
        setTimeout(() => {
          setcompanyNameError('.');
          inputcompanyNameRef.current.focus();
        }, 50);
      } else if (!selectedCloud) {
        setcloudError('Select Cloud');
      } else if (!selectedRegion) {
        setregionError('Select Region');
      }
    } else {
      handleSubmitButton();
    }
  };
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (refreshKey > 0 && sessionStorage.getItem('company_id')) {
      getCompanySubscriptionStatus(sessionStorage.getItem('company_id'));
    }
  }, [refreshKey]);

  const getCompanySubscriptionStatus = (company_id) => {
    commonServices
      .getCompanySubscriptionStatus(company_id)
      .then((res: any) => {
        if (res.data.is_company_subscribed) {
          setpaymentStatus('success');
          sessionStorage.clear();
        } else {
          setpaymentStatus('failure');
        }
      })
      .catch((error: any) => {
        console.log('Error fetching company subscription status:', error);
      })
      .finally(() => {
        setinitiatePayment(false);
      });
  };
  const retryPayment = (company_id) => {
    commonServices
      .getCompanySubscriptionStatus(company_id)
      .then((res: any) => {
        setinitiatePayment(true);
        const newWindow = window.open(
          res?.data?.payment_link,
          'payment-popup',
          'width=800,height=600',
        );
        if (newWindow) {
          const interval = setInterval(() => {
            if (newWindow.closed) {
              clearInterval(interval);
              setRefreshKey((prevKey) => prevKey + 1);
            }
          }, 500);
        }
      })
      .catch((error: any) => {
        getCompanySubscriptionStatus(company_id);
      })
      .finally(() => {
        setinitiatePayment(false);
      });
  };

  const handleSubmitButton = () => {
    setregisterErrorText('');
    setregisterSuccessText('');
    if (
      !firstNameError &&
      !lastNameError &&
      !phoneNumberError &&
      !emailIdError &&
      !companyNameError &&
      companyName.length > 1 &&
      !cityNameError &&
      !countryNameError &&
      selectedCloud &&
      selectedRegion &&
      selectedSubscriptionType &&
      selectedSubscriptionPlan
    ) {
      const temp = {
        first_name: firstName.trim(),
        last_name: lastName.trim(),
        phone_number: countryCode.value + phoneNumber,
        email_id: emailId.trim(),
        company_name: companyName.trim(),
        city: cityName.trim(),
        country: countryName.trim(),
        cloud: selectedCloud.label,
        region: selectedRegion.label,
        subscription: selectedSubscriptionPlan?.value,
        subscription_plan_id: selectedSubscriptionType?.value,
        provider: 'WEB',
        identifier: null,
        company_name_ref: '',
      };
      commonServices
        .registerAPI(temp)
        .then((res: any) => {
          setErrorText('');
          setfirstName('');
          setlastName('');
          setemailId('');
          setphoneNumber('');
          setcityName('');
          setcountryName('');
          setcompanyName('');
          setselectedSubscriptionPlan(null);
          setselectedSubscriptionType(null);
          setselectedCloud(null);
          setselectedRegion(null);
          if (res?.data?.message) {
            setregisterSuccessText(res.data.message);
            setshowRegisterSuccessScreen(true);
          }
          if (sessionStorage.getItem('subscription')) {
            sessionStorage.removeItem('subscription');
          }
          if (res?.data?.payment_link) {
            sessionStorage.setItem('company_id', res.data.company_id);
            setinitiatePayment(true);
            const newWindow = window.open(
              res?.data?.payment_link,
              'payment-popup',
              'width=800,height=600',
            );
            if (newWindow) {
              const interval = setInterval(() => {
                if (newWindow.closed) {
                  clearInterval(interval);
                  setRefreshKey((prevKey) => prevKey + 1);
                }
              }, 500);
            }
            dispatch(Loadingfuction({ loading: false }));
          }

          // navigate('/registration-success');
        })
        .catch((error: any) => {
          setregisterErrorText(error.data.message);
          setshowRegisterSuccessScreen(true);
          if (error?.data?.payment_link) {
            sessionStorage.setItem('company_id', error.data.company_id);
            sessionStorage.setItem('payment_link', error.data.payment_link);
            const newWindow = window.open(
              error?.data?.payment_link,
              'payment-popup',
              'width=800,height=600',
            );
            if (newWindow) {
              const interval = setInterval(() => {
                if (newWindow.closed) {
                  clearInterval(interval);
                  setRefreshKey((prevKey) => prevKey + 1);
                }
              }, 500);
            }
          }
          dispatch(Loadingfuction({ loading: false }));
          if (sessionStorage.getItem('subscription')) {
            sessionStorage.removeItem('subscription');
          }
        });
    } else {
      if (companyName.length < 1 || companyName.length > 100) {
        if (companyName.length == 0) {
          setcompanyNameError(TextMsg.registercompanyNameError);
          inputcompanyNameRef.current.focus();
        } else if (companyName.length > 100) {
          setTimeout(() => {
            setcompanyNameError('.');
            inputcompanyNameRef.current.focus();
          }, 50);
        }
      } else if (!selectedCloud) {
        setcloudError('Select Cloud');
      } else if (!selectedRegion) {
        setregionError('Select Region');
      } else if (!selectedSubscriptionType || !selectedSubscriptionPlan) {
        setsubscriptionError('Select Subscription Type and Plan');
      }
    }
  };
  const [subscriptionList, setsubscriptionList] = useState([]);
  const [selectedSubscriptionType, setselectedSubscriptionType] =
    useState(null);
  const [selectedSubscriptionPlan, setselectedSubscriptionPlan] =
    useState(null);

  const getSubscriptionDetails = () => {
    commonServices
      .subscriptionDetailsAPI()
      .then((res: any) => {
        console.log(res);
        const temp = [];
        res.data.data.forEach((element) => {
          if (element.id != 7) {
            temp.push({
              label: element.name,
              value: element.id,
              plan_details: Object.entries(element.plan_details).map(
                ([key, val]) => ({
                  label: key.charAt(0).toUpperCase() + key.slice(1),
                  value: val,
                }),
              ),
            });
          }
        });
        setsubscriptionList(temp);
        if (sessionStorage.getItem('subscription')) {
          const subscriptionDetails = JSON.parse(
            sessionStorage.getItem('subscription'),
          );
          const selectedSub = temp.find(
            (e) => e.value == subscriptionDetails.subscription_id,
          );
          setselectedSubscriptionPlan(selectedSub);
          setselectedSubscriptionType(
            selectedSub.plan_details.find(
              (e) => e.value == subscriptionDetails.subscription_type,
            ),
          );
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  const handleCloudChange = (selected) => {
    setselectedCloud(selected);
    setcloudError('');
  };
  const handleRegionChange = (selected) => {
    setselectedRegion(selected);
    setregionError('');
  };

  const [initiatePayment, setinitiatePayment] = useState(false);
  const [paymentStatus, setpaymentStatus] = useState('');

  return (
    <section className='header-section mt-3 overflow-auto'>
      <div className='container login-container'>
        <div className='row g-0 align-items-center py-2 justify-content-center h-100'>
          <div className='col-sm-12 col-md-10 col-lg-8 col-xl-8 px-1 px-lg-12 d-flex justify-content-center py-3 rounded-5'>
            {!showRegisterSuccessScreen && (
              <div className='bg-d-s px-3 px-lg-4 py-1 w-100 login-box'>
                <div>
                  <div className='mt-2 mb-4'>
                    <h1 className='fw-bold'>Register</h1>
                    <div className='mt-2'>
                      {' '}
                      Already have an account?{' '}
                      <span
                        className='link_tag_button'
                        onClick={() => {
                          navigate('/login');
                        }}
                      >
                        Sign in
                      </span>{' '}
                    </div>
                  </div>
                  <div className='d-flex g-1'>
                    <div className='w-50 pe-1'>
                      <div className='my-4 position-relative'>
                        <TextInput
                          className={
                            'rounded-1 fw-medium w-100 py-2 px-2 ' +
                            (!firstNameError ? 'border-grey-1' : 'error-border')
                          }
                          id='firstname'
                          type='text'
                          value={firstName}
                          onChange={(event) => {
                            handlefirstNameValue(event);
                          }}
                          handleAction={() => {
                            handlenextButton();
                          }}
                          tabIndex={0}
                          placeholder={TextMsg.registerFirstNameplaceholder}
                          autofocus
                          inputLabel={TextMsg.registerFirstNameLabel}
                          inputref={inputFirstNameRef}
                          texterror={firstNameError}
                          textInputLabel={TextMsg.registerFirstNameLabel}
                          maxLength={50}
                        />
                      </div>
                    </div>
                    <div className='w-50 position-relative my-4'>
                      <TextInput
                        className={
                          'rounded-1 fw-medium w-100 py-2 px-2 ' +
                          (!lastNameError ? 'border-grey-1' : 'error-border')
                        }
                        type='text'
                        value={lastName}
                        onChange={(event) => {
                          handlelastNameValue(event);
                        }}
                        handleAction={() => {
                          handlenextButton();
                        }}
                        tabIndex={0}
                        placeholder={TextMsg.registerLastNameplaceholder}
                        inputref={inputlastNameRef}
                        texterror={lastNameError}
                        maxLength={50}
                        inputLabel={TextMsg.registerLastNameLabel}
                        textInputLabel={TextMsg.registerLastNameLabel}
                      />
                    </div>
                  </div>
                </div>
                <div className='my-2 w-100 position-relative'>
                  <TextInput
                    className={
                      'rounded-1 fw-medium w-100 py-2 px-2 ' +
                      (!emailIdError ? 'border-grey-1' : 'error-border')
                    }
                    type='text'
                    value={emailId}
                    onChange={(event) => {
                      handleemailIdValue(event);
                    }}
                    handleAction={() => {
                      handlenextButton();
                    }}
                    tabIndex={0}
                    placeholder={TextMsg.registeremailIdplaceholder}
                    inputref={inputemailIdRef}
                    texterror={emailIdError}
                    maxLength={256}
                    inputLabel={TextMsg.registeremailIdLabel}
                    textInputLabel={TextMsg.registeremailIdLabel}
                  />
                </div>
                <div className='d-flex my-4'>
                  <div className='w-60 pe-1 my-2'>
                    <div className='d-flex'>
                      <div className='w-40 me-2'>
                        <DropDown
                          placeholder={'Select Country Code'}
                          selectedOption={countryCode}
                          options={countryCodes}
                          isMulti={false}
                          handleSelectChange={handleCountryCodeChange}
                          tabIndex={0}
                          //Width={100}
                        />
                      </div>
                      <div className='w-60 position-relative'>
                        <TextInput
                          className={
                            'rounded-1 fw-medium w-100 py-2 px-2 ' +
                            (!phoneNumberError
                              ? 'border-grey-1'
                              : 'error-border')
                          }
                          type='text'
                          value={phoneNumber}
                          onChange={(event) => {
                            handlephoneNumberValue(event);
                          }}
                          handleAction={() => {
                            handlenextButton();
                          }}
                          tabIndex={0}
                          placeholder={TextMsg.registerphoneNumberplaceholder}
                          inputref={inputphoneNumberRef}
                          texterror={phoneNumberError}
                          textInputLabel={TextMsg.registerphoneNumberLabel}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-40 my-2 position-relative'>
                    <TextInput
                      className={
                        'rounded-1 fw-medium w-100 py-2 px-2 ' +
                        (!cityNameError ? 'border-grey-1' : 'error-border')
                      }
                      type='text'
                      value={cityName}
                      onChange={(event) => {
                        handlecityNameValue(event);
                      }}
                      handleAction={() => {
                        handlenextButton();
                      }}
                      tabIndex={0}
                      placeholder={TextMsg.registercityNameplaceholder}
                      inputref={inputcityNameRef}
                      texterror={cityNameError}
                      maxLength={100}
                      inputLabel={TextMsg.registercityNameLabel}
                      textInputLabel={TextMsg.registercityNameLabel}
                    />
                  </div>
                </div>
                <div className='d-flex'>
                  <div className='w-50 pe-1 position-relative'>
                    <TextInput
                      className={
                        'rounded-1 fw-medium w-100 py-2 px-2 ' +
                        (!countryNameError ? 'border-grey-1' : 'error-border')
                      }
                      type='text'
                      value={countryName}
                      onChange={(event) => {
                        handlecountryNameValue(event);
                      }}
                      handleAction={() => {
                        handlenextButton();
                      }}
                      tabIndex={0}
                      placeholder={TextMsg.registercountryNameplaceholder}
                      inputref={inputcountryNameRef}
                      texterror={countryNameError}
                      maxLength={100}
                      inputLabel={TextMsg.registercountryNameLabel}
                      textInputLabel={TextMsg.registercountryNameLabel}
                    />
                  </div>
                  <div className='w-50 position-relative'>
                    <TextInput
                      className={
                        'rounded-1 fw-medium w-100 py-2 px-2 ' +
                        (!companyNameError ? 'border-grey-1' : 'error-border')
                      }
                      type='text'
                      value={companyName}
                      onChange={(event) => {
                        handlecompanyNameValue(event);
                      }}
                      handleAction={() => {
                        handlenextButton();
                      }}
                      tabIndex={0}
                      placeholder={TextMsg.registercompanyNameplaceholder}
                      inputref={inputcompanyNameRef}
                      texterror={companyNameError}
                      maxLength={100}
                      inputLabel={TextMsg.registercompanyNameLabel}
                      textInputLabel={TextMsg.registercompanyNameLabel}
                    />
                  </div>
                </div>
                <div className='d-flex'>
                  <div className='w-100 my-4 position-relative'>
                    <DropDown
                      placeholder={'Select Subscription'}
                      selectedOption={selectedSubscriptionPlan}
                      options={subscriptionList}
                      isMulti={false}
                      handleSelectChange={(event) => {
                        setselectedSubscriptionPlan(event);
                        setselectedSubscriptionType(null);
                        // setselectedSubscriptionType(event?.plan_details[0]);
                        setsubscriptionError('');
                      }}
                      tabIndex={0}
                      dropDownLabel={'Subscription Plan'}
                      disabled={
                        sessionStorage.getItem('subscription') ? true : false
                      }
                    />
                  </div>
                  <div className='w-100 ms-1 my-4 position-relative'>
                    <DropDown
                      placeholder={'Select Subscription Type'}
                      selectedOption={selectedSubscriptionType}
                      options={selectedSubscriptionPlan?.plan_details || []}
                      isMulti={false}
                      disabled={!selectedSubscriptionPlan}
                      handleSelectChange={(event) => {
                        setselectedSubscriptionType(event);
                      }}
                      tabIndex={0}
                      dropDownLabel={'Plan Type ( Annual / Monthly )'}
                    />
                  </div>
                </div>
                <div className='d-flex my-2'>
                  <div className='w-50 pe-1'>
                    <DropDown
                      placeholder={'Select Cloud'}
                      selectedOption={selectedCloud}
                      options={cloudList}
                      isMulti={false}
                      handleSelectChange={handleCloudChange}
                      tabIndex={0}
                      dropDownLabel={TextMsg.registerCloudLabel}
                    />
                    {cloudError && <h5 className='error-text'>{cloudError}</h5>}
                  </div>
                  <div className='w-50'>
                    <DropDown
                      placeholder={'Select Region'}
                      selectedOption={selectedRegion}
                      options={regionList}
                      isMulti={false}
                      handleSelectChange={handleRegionChange}
                      tabIndex={0}
                      dropDownLabel={TextMsg.registerRegionLabel}
                      disabled={!selectedCloud}
                    />
                    {regionError && (
                      <h5 className='error-text'>{regionError}</h5>
                    )}
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-end'>
                  <ButtonComp
                    buttonClass='btn py-2 fw-bold text-center mt-4 mb-4 w-25 rounded-1'
                    ariaLabel='Register'
                    label='Register'
                    handleButtonClick={() => {
                      handlenextButton();
                    }}
                    tabIndex={1}
                  />
                </div>
              </div>
            )}

            {showRegisterSuccessScreen && (
              <div className='text-center mt-5 h-100 '>
                {registerErrorText ? (
                  <h1 className='fw-medium bg-p p-2 rounded-2 mx-2 text_subheding_bold w-100 text-center error-text'>
                    {registerErrorText}
                  </h1>
                ) : (
                  <span className='fw-medium bg-p p-2 rounded-2 mx-2 text_subheding_bold w-100 text-center '>
                    {registerSuccessText}
                  </span>
                )}
                {initiatePayment && (
                  <>
                    <Image
                      imageClass='loader_css mt-4'
                      src='\asset\loader.gif'
                      alt='In Progress'
                      ariaLabel='Payment in Progress'
                    ></Image>

                    <span className='fw-medium mt-3 me-2 text_subheding_bold '>
                      Payment is in Progress
                    </span>
                    <h4 className='fw-medium mt-3'>
                      Please Check status below
                    </h4>
                  </>
                )}
                {paymentStatus == 'failure' && (
                  <>
                    <Image
                      imageClass='loader_css mt-4'
                      src='\asset\langing_page_icons\failure.png'
                      alt='Payment Failed'
                      ariaLabel='Payment Failed'
                    ></Image>

                    <span className='fw-medium mt-3 me-2 text_subheding_bold error-text'>
                      Payment Failed
                    </span>
                    <h4 className='fw-medium mt-3'>Please try again</h4>
                  </>
                )}
                {paymentStatus == 'success' && (
                  <>
                    <Image
                      imageClass='loader_css mt-4'
                      src='\asset\langing_page_icons\success.png'
                      alt='Success'
                      ariaLabel='Success'
                    ></Image>

                    <span className='fw-medium mt-3 me-2 text-success text_subheding_bold'>
                      Payment Successful
                    </span>
                    <h4 className='fw-medium mt-3'>
                      Please click below to login
                    </h4>
                  </>
                )}
                {registerErrorText ? (
                  <ButtonComp
                    buttonClass='btn px-4 py-2 fw-bold text-center mt-5 mb-4 rounded-1'
                    ariaLabel='Back to Register'
                    label='Back to Register'
                    handleButtonClick={() => {
                      setshowRegisterSuccessScreen(false);
                    }}
                    tabIndex={0}
                  />
                ) : registerSuccessText ? (
                  <>
                    {initiatePayment ? (
                      <>
                        <ButtonComp
                          buttonClass='btn px-4 py-2 fw-bold text-center mt-3 mb-4 rounded-1'
                          ariaLabel='Refresh Status'
                          label='Refresh Status'
                          handleButtonClick={() => {
                            if (sessionStorage.getItem('company_id')) {
                              getCompanySubscriptionStatus(
                                sessionStorage?.getItem('company_id'),
                              );
                            }
                          }}
                          tabIndex={0}
                        />
                      </>
                    ) : (
                      <>
                        {paymentStatus == 'failure' ? (
                          <ButtonComp
                            buttonClass='btn px-4 py-2 fw-bold text-center mt-3 mb-4 rounded-1'
                            ariaLabel='Retry Payment'
                            label='Retry Payment'
                            handleButtonClick={() => {
                              if (sessionStorage.getItem('company_id')) {
                                retryPayment(
                                  sessionStorage.getItem('company_id'),
                                );
                              }
                            }}
                            tabIndex={0}
                          />
                        ) : (
                          <ButtonComp
                            buttonClass='btn px-4 py-2 fw-bold text-center mt-3 mb-4 rounded-1 '
                            ariaLabel='Sign in'
                            label='Sign in'
                            handleButtonClick={() => {
                              navigate('/login');
                            }}
                            tabIndex={0}
                          />
                        )}
                      </>
                    )}
                  </>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
